module.exports = __webpack_public_path__ + "assets/img/18_1778_big.c588fa39.jpg";